
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"12","height":"12","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M5.5 4.494h2a.5.5 0 100-1h-1v-.5a.5.5 0 00-1 0v.5a1.5 1.5 0 000 3h1a.5.5 0 110 1h-2a.5.5 0 100 1h1v.5a.5.5 0 101 0v-.5a1.5 1.5 0 100-3h-1a.5.5 0 110-1zm4-3.5h-7a1.5 1.5 0 00-1.5 1.5v7a1.5 1.5 0 001.5 1.5h7a1.5 1.5 0 001.5-1.5v-7a1.5 1.5 0 00-1.5-1.5zm.5 8.5a.5.5 0 01-.5.5h-7a.5.5 0 01-.5-.5v-7a.5.5 0 01.5-.5h7a.5.5 0 01.5.5v7z","fill":"#000C1F","fill-opacity":".8"}})])
          )
        }
      }
    